/* Site-wide menu, cart and chat scripts that used to sit inline at the end of every page. Kept in the same order. */
;document.addEventListener("DOMContentLoaded", function () {
    function changeMenuIcons() {
      if (!window.matchMedia("(max-width: 989px)").matches) return;

      document.querySelectorAll(".nh-premium-mobile-card").forEach(function (card) {
        var title = card.querySelector(".nh-menu-title");
        var action = card.querySelector(".nh-menu-action");

        if (!title || !action) return;

        var text = title.textContent.trim().toUpperCase();

        if (
          text === "WELLNESS COMBOS" ||
          text === "ACCESSORIES" ||
          text === "CONTACT"
        ) {
          action.textContent = "›";
        }
      });
    }

    changeMenuIcons();

    document.addEventListener("click", function () {
      setTimeout(changeMenuIcons, 250);
    });
  });


;document.addEventListener("DOMContentLoaded", function () {
    function updateMenuState() {
      var menuOpen =
        document.querySelector('header details[open]') ||
        document.body.classList.contains('menu-drawer-overlay-on') ||
        document.body.classList.contains('drawer-open') ||
        document.body.classList.contains('mobile-menu-open');

      if (menuOpen) {
        document.body.classList.add('nh-menu-open');
      } else {
        document.body.classList.remove('nh-menu-open');
      }
    }

    document.addEventListener('click', function () {
      setTimeout(updateMenuState, 100);
      setTimeout(updateMenuState, 400);
    });

    document.addEventListener('touchend', function () {
      setTimeout(updateMenuState, 100);
      setTimeout(updateMenuState, 400);
    });

    updateMenuState();
  });


;document.addEventListener("DOMContentLoaded", function () {
    const menuItems = {
      "INDOOR SAUNAS": {
        subtitle: "Traditional, infrared and full spectrum"
      },
      "OUTDOOR SAUNAS": {
        subtitle: "Built for Australian conditions"
      },
      "ICE BATHS": {
        subtitle: "Cold and hot recovery at home"
      },
      "WELLNESS COMBOS": {
        subtitle: "Complete sauna and ice bath packages"
      },
      "ACCESSORIES": {
        subtitle: "Upgrade your wellness setup"
      },
      "CONTACT": {
        subtitle: "Speak with our team"
      }
    };

    function upgradeMobileMenu() {
      if (!window.matchMedia("(max-width: 989px)").matches) return;

      const drawers = document.querySelectorAll(
        '.menu-drawer, #menu-drawer, .mobile-menu, .nav-drawer, .navigation-drawer, [class*="menu-drawer"], [class*="mobile-menu"], [class*="nav-drawer"]'
      );

      drawers.forEach(function (drawer) {

        /* Do not touch the footer */
        if (drawer.closest("footer, .footer, .footer-group, [class*='footer']")) return;

        const items = drawer.querySelectorAll("a, summary");

        items.forEach(function (item) {

          /* Extra footer protection */
          if (item.closest("footer, .footer, .footer-group, [class*='footer']")) return;

          const rawText = item.textContent
            .replace(/\s+/g, " ")
            .replace(/\+/g, "")
            .replace(/›/g, "")
            .trim()
            .toUpperCase();

          if (!menuItems[rawText]) return;
          if (item.classList.contains("nh-premium-mobile-card")) return;

          const data = menuItems[rawText];
          const isContact = rawText === "CONTACT";
          const isSimpleLink = ["WELLNESS COMBOS", "ACCESSORIES", "CONTACT"].includes(rawText);

          item.classList.add("nh-premium-mobile-card");

          item.innerHTML = `
            <span class="nh-menu-text">
              <span class="nh-menu-title">${rawText}</span>
              <span class="nh-menu-subtitle">${data.subtitle}</span>
            </span>
            <span class="nh-menu-action">${isSimpleLink ? "›" : "+"}</span>
          `;
        });
      });
    }

    upgradeMobileMenu();

    document.addEventListener("click", function () {
      setTimeout(upgradeMobileMenu, 150);
      setTimeout(upgradeMobileMenu, 400);
    });

    const observer = new MutationObserver(function () {
      upgradeMobileMenu();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });


;document.addEventListener('DOMContentLoaded', function () {
    function checkCartOpen() {
      var cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, .drawer');

      if (!cartDrawer) return;

      var isOpen =
        cartDrawer.classList.contains('active') ||
        cartDrawer.classList.contains('is-open') ||
        cartDrawer.getAttribute('open') !== null ||
        cartDrawer.getAttribute('aria-hidden') === 'false';

      if (isOpen) {
        document.body.classList.add('cart-drawer-open');
      } else {
        document.body.classList.remove('cart-drawer-open');
      }
    }

    document.addEventListener('click', function () {
      setTimeout(checkCartOpen, 300);
    });

    checkCartOpen();
  });


;(function () {
    if (window.innerWidth > 749) return;
    if (window.location.pathname !== '/collections/outdoor-traditional-saunas') return;

    var userHasScrolled = false;
    var blockUntil = Date.now() + 5000;

    function shouldBlockAutoScroll() {
      return !userHasScrolled && Date.now() < blockUntil;
    }

    function goTop() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    }

    window.addEventListener('touchstart', function () {
      userHasScrolled = true;
    }, { passive: true });

    window.addEventListener('wheel', function () {
      userHasScrolled = true;
    }, { passive: true });

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (window.location.hash) {
      history.replaceState(null, document.title, window.location.pathname + window.location.search);
    }

    var originalScrollTo = window.scrollTo;
    var originalScrollBy = window.scrollBy;
    var originalScrollIntoView = Element.prototype.scrollIntoView;

    window.scrollTo = function () {
      if (shouldBlockAutoScroll()) {
        originalScrollTo.call(window, 0, 0);
        return;
      }
      return originalScrollTo.apply(window, arguments);
    };

    window.scrollBy = function () {
      if (shouldBlockAutoScroll()) {
        originalScrollTo.call(window, 0, 0);
        return;
      }
      return originalScrollBy.apply(window, arguments);
    };

    Element.prototype.scrollIntoView = function () {
      if (shouldBlockAutoScroll()) {
        originalScrollTo.call(window, 0, 0);
        return;
      }
      return originalScrollIntoView.apply(this, arguments);
    };

    goTop();

    var timer = setInterval(function () {
      if (shouldBlockAutoScroll()) {
        goTop();
      } else {
        clearInterval(timer);
        window.scrollTo = originalScrollTo;
        window.scrollBy = originalScrollBy;
        Element.prototype.scrollIntoView = originalScrollIntoView;
      }
    }, 100);
  })();


;(function () {
    function tidioClosed() {
      document.body.classList.remove('tidio-chat-open');
    }

    function tidioOpen() {
      document.body.classList.add('tidio-chat-open');
    }

    function onTidioReady() {
      tidioClosed();

      if (window.tidioChatApi) {
        window.tidioChatApi.on('open', tidioOpen);
        window.tidioChatApi.on('close', tidioClosed);
      }
    }

    if (window.tidioChatApi) {
      window.tidioChatApi.on('ready', onTidioReady);
    } else {
      document.addEventListener('tidioChat-ready', onTidioReady);
    }
  })();
